export default __webpack_public_path__ + "static/media/awka-terminal.e890cb02.png";